import React from 'react';
import Navigation from './../../Home/Navigation/Navigation';


const Blogs = () => {
    return (
        <div>
            <Navigation />
            <hr className="text-center text-white w-75 mx-auto" />
            <h1 className="text-white text-center">Blog Section Coming Soon</h1>
            
        </div>
    );
};

export default Blogs;